module.exports = __webpack_public_path__ + "media/packs/google-ads-43e01a55d1997963cb356a7edb1ccdc0.svg";